import React,{useState,useEffect} from 'react'
import CommonButton from '../../subComponents/CommonButton'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import { flexValueTable } from '../../../utils/AdminDashApi/FlexValue'
import ReactPaginate from 'react-paginate';
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import Purplebutton from './subComponent/Purplebutton'
import { fetchFlexSetDrpDown } from '../../../utils/Api_Calls/api_calls_all'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
const FlexValueComp = () => {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
  }
  const [flexvaluesetdrp,setflexvaluesetdrp] = useState("")
  const [flexvaluesetIDdrp,setflexvaluesetIDdrp] = useState("")
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
 
  
  const [activetonewFlexValue,setactiveTonewFlexValue] = useState("")

  const [flexnameMod1,setflexnameMod1] = useState("")
  const [labelflexnameMod1,setlabelflexnameMod1] = useState("")
  const [borderflexnameMod1,setborderflexnameMod1] = useState("")

  const [flexnameMod2,setflexnameMod2] = useState("")
  const [labelflexnameMod2,setlabelflexnameMod2] = useState("")
  const [borderflexnameMod2,setborderflexnameMod2] = useState("")

  const [shortnameMain,setshortnameMain] = useState("")
  const [labelshortnameMain,setlabelshortnameMain] = useState("")
  const [bordershortnameMain,setbordershortnameMain] = useState("")

  const [flexvaluesetidMod1,setflexvaluesetidMod1] = useState("")
  const [labelflexvaluesetidMod1,setlabelflexvaluesetidMod1] = useState("")
  const [borderflexvaluesetidMod1,setborderflexvaluesetidMod1] = useState("")

  const [flexshortnameMod1,setflexshortnameMod1] = useState("")
  const [labelflexshortnameMod1,setlabelflexshortnameMod1] = useState("")
  const [borderflexshortnameMod1,setborderflexshortnameMod1] = useState("")

  const [flexshortnameMod2,setflexshortnameMod2] = useState("")
  const [labelflexshortnameMod2,setlabelflexshortnameMod2] = useState("")
  const [borderflexshortnameMod2,setborderflexshortnameMod2] = useState("")

  const [flexvalueMod1,setflexvalueMod1] = useState("")
  const [borderflexvalueMod1,setborderflexvalueMod1] = useState("")
  const [labelflexvalueMod1,setlabelflexvalueMod1] = useState("")


  const [activefromMod1,setactivefromMod1] = useState("")
  const [borderactivefromMod1,setborderactivefromMod1] = useState("")
  const [labelactivefromMod1,setlabelactivefromMod1] = useState("")

  const [activetoMod1,setactivetoMod1] = useState("")
  const [borderactivetoMod1,setborderactivetoMod1] = useState("")
  const [labelactivetoMod1,setlabelactivetoMod1] = useState("")

  const [flexvaluesetidMod2,setflexvaluesetidMod2] = useState("")
  const [labelflexvaluesetidMod2,setlabelflexvaluesetidMod2] = useState("")
  const [borderflexvaluesetidMod2,setborderflexvaluesetidMod2] = useState("")

  const [flexvalueMod2,setflexvalueMod2] = useState("")
  const [borderflexvalueMod2,setborderflexvalueMod2] = useState("")
  const [labelflexvalueMod2,setlabelflexvalueMod2] = useState("")

  const [flexshortvalueMod2,setflexshortvalueMod2] = useState("")
  const [borderflexshortvalueMod2,setborderflexshortvalueMod2] = useState("")
  const [labelflexshortvalueMod2,setlabelflexshortvalueMod2] = useState("")

  const [activefromMod2,setactivefromMod2] = useState("")
  const [borderactivefromMod2,setborderactivefromMod2] = useState("")
  const [labelactivefromMod2,setlabelactivefromMod2] = useState("")

  const [activetoMod2,setactivetoMod2] = useState("")
  const [borderactivetoMod2,setborderactivetoMod2] = useState("")
  const [labelactivetoMod2,setlabelactivetoMod2] = useState("")

  const [flexsetnamemod3,setflexsetnamemod3] = useState("")
  const [borderflexsetnamemod3,setborderflexsetnamemod3] = useState("")
  const [labelflexsetnamemod3,setlabelflexsetnamemod3] = useState("")
  
  const [flexshortnamemod3,setflexshortnamemod3] = useState("")
  const [borderflexshortnamemod3,setborderflexshortnamemod3] = useState("")
  const [labelflexshortnamemod3,setlabelflexshortnamemod3] = useState("")

  const [attribute1Mod1,setattribute1Mod1] = useState("")
  const [labelattribute1Mod1,setlabelattribute1Mod1] = useState("")
  const [borderattribute1Mod1,setborderattribute1Mod1] = useState("")

  const [attribute2Mod1, setattribute2Mod1] = useState("");
  const [labelattribute2Mod1, setlabelattribute2Mod1] = useState("");
  const [borderattribute2Mod1, setborderattribute2Mod1] = useState("");
  
  const [attribute3Mod1, setattribute3Mod1] = useState("");
  const [labelattribute3Mod1, setlabelattribute3Mod1] = useState("");
  const [borderattribute3Mod1, setborderattribute3Mod1] = useState("");
  
  const [attribute4Mod1, setattribute4Mod1] = useState("");
  const [labelattribute4Mod1, setlabelattribute4Mod1] = useState("");
  const [borderattribute4Mod1, setborderattribute4Mod1] = useState("");
  
  const [attribute5Mod1, setattribute5Mod1] = useState("");
  const [labelattribute5Mod1, setlabelattribute5Mod1] = useState("");
  const [borderattribute5Mod1, setborderattribute5Mod1] = useState("");

  const [attribute1Mod2,setattribute1Mod2] = useState("")
  const [labelattribute1Mod2,setlabelattribute1Mod2] = useState("")
  const [borderattribute1Mod2,setborderattribute1Mod2] = useState("")

  const [attribute2Mod2, setattribute2Mod2] = useState("");
  const [labelattribute2Mod2, setlabelattribute2Mod2] = useState("");
  const [borderattribute2Mod2, setborderattribute2Mod2] = useState("");
  
  const [attribute3Mod2, setattribute3Mod2] = useState("");
  const [labelattribute3Mod2, setlabelattribute3Mod2] = useState("");
  const [borderattribute3Mod2, setborderattribute3Mod2] = useState("");
  
  const [attribute4Mod2, setattribute4Mod2] = useState("");
  const [labelattribute4Mod2, setlabelattribute4Mod2] = useState("");
  const [borderattribute4Mod2, setborderattribute4Mod2] = useState("");
  
  const [attribute5Mod2, setattribute5Mod2] = useState("");
  const [labelattribute5Mod2, setlabelattribute5Mod2] = useState("");
  const [borderattribute5Mod2, setborderattribute5Mod2] = useState("");

  const [flexvaluesetMod1,setflexvaluesetMod1] = useState("")
  const [labelflexvaluesetMod1,setlabelflexvaluesetMod1] = useState("")
  const [borderflexvaluesetMod1,setborderflexvaluesetMod1] = useState("")
  
  const [FlexSetResponse, setFlexSetResponse] = useState([]);
  const [FlexValueListResponse, setFlexValueListResponse] = useState([]);

  useEffect(() => {
    const fetchFlexSetdrp = async () => {
      const data = await fetchFlexSetDrpDown();
      setFlexSetResponse(data);
      };
      fetchFlexSetdrp(); 
  }, []);
  const handleSaveFlexValue= async ()=>{

    let isFormvalid = false 
    const validationResults = [];

    validationResults.push(validationDrp(flexnameMod1,setlabelflexnameMod1,setborderflexnameMod1,"Flex Value required"))
    validationResults.push(validationDrp(flexshortnameMod1,setlabelflexshortnameMod1,setborderflexshortnameMod1,"Flex Short Name required"))
    // validationResults.push(validationDrp(attribute1Mod1,setlabelattribute1Mod1,setborderattribute1Mod1,"Attribute 1 required"))
    // validationResults.push(validationDrp(attribute2Mod1,setlabelattribute2Mod1,setborderattribute2Mod1,"Attribute 2 required"))
    // validationResults.push(validationDrp(attribute3Mod1,setlabelattribute3Mod1,setborderattribute3Mod1,"Attribute 3 required"))
    // validationResults.push(validationDrp(attribute4Mod1,setlabelattribute4Mod1,setborderattribute4Mod1,"Attribute 4 required"))
    // validationResults.push(validationDrp(attribute5Mod1,setlabelattribute5Mod1,setborderattribute5Mod1,"Attribute 5 required"))
    // validationResults.push(validationDrp(activefromMod1,setlabelactivefromMod1,setborderactivefromMod1,"Active From Required"))
    // validationResults.push(validationDrp(activetoMod1,setlabelactivetoMod1,setborderactivetoMod1,"Active To Required"))
    // validationResults.push(validationDrp(flexvaluesetMod1,setlabelflexvaluesetMod1,setborderflexvaluesetMod1,"Flex Value Set Required"))
    if(flexvaluesetdrp){
      setlabelflexvaluesetMod1("")
      setborderflexvaluesetMod1("")
    }
    if (validationResults.every(result => result === true)) {
      isFormvalid = true; // Set isFormvalid to true if all results are true
    }

    if(isFormvalid){
      console.log("first modal")
      const mod1FinalArray = {
        "fleX_VALUE_ID":0,
        "fleX_VALUE":flexnameMod1,
        "fleX_SHORT_VALUE":flexshortnameMod1,
        "fleX_VALUE_SET_ID":flexvaluesetIDdrp,
        "attributE1":attribute1Mod1,
        "attributE2":attribute2Mod1,
        "attributE3":attribute3Mod1,
        "attributE4":attribute4Mod1,
        "attributE5":attribute5Mod1
      }
      
      await SaveOrUpdateFlexValue(mod1FinalArray);
      setShow2(false)
    }

  }
  //Update
  const handlesaveMod2= async ()=>{
    let isFormvalid = false 
    const validationResults = [];
    validationResults.push(validationComp(flexnameMod2,setlabelflexnameMod2,setborderflexnameMod2,"Flex Value required",""))
    validationResults.push(validationComp(flexshortnameMod2,setlabelflexshortnameMod2,setborderflexshortnameMod2,"Flex Short Name required",""))
    // validationResults.push(validationDrp(attribute1Mod2,setlabelattribute1Mod2,setborderattribute1Mod2,"Attribute 1 required"))
    // validationResults.push(validationDrp(attribute2Mod2,setlabelattribute2Mod2,setborderattribute2Mod2,"Attribute 2 required"))
    // validationResults.push(validationDrp(attribute3Mod2,setlabelattribute3Mod2,setborderattribute3Mod2,"Attribute 3 required"))
    // validationResults.push(validationDrp(attribute4Mod2,setlabelattribute4Mod2,setborderattribute4Mod2,"Attribute 4 required"))
    // validationResults.push(validationDrp(attribute5Mod2,setlabelattribute5Mod2,setborderattribute5Mod2,"Attribute 5 required")  )
    // validationResults.push(validationDrp(activefromMod2,setlabelactivefromMod2,setborderactivefromMod2,"Active From Required")  )
    // validationResults.push(validationDrp(activetoMod2,setlabelactivetoMod2,setborderactivetoMod2,"Active To Required"))

    if (validationResults.every(result => result === true)) {
      isFormvalid = true; // Set isFormvalid to true if all results are true
    }
    if(isFormvalid){
      console.log("ami update")
      const mod2FinalArray = {
        "fleX_VALUE_ID":SelectedRowId,
        "fleX_VALUE":flexnameMod2,
        "fleX_SHORT_VALUE":flexshortnameMod2,
        "fleX_VALUE_SET_ID":flexvaluesetIDdrp,
        "attributE1":attribute1Mod2,
        "attributE2":attribute2Mod2,
        "attributE3":attribute3Mod2,
        "attributE4":attribute4Mod2,
        "attributE5":attribute5Mod2,
      }
      console.log(mod2FinalArray);
      await SaveOrUpdateFlexValue(mod2FinalArray);
      setShow3(false)
    }
    console.log("not entered")
  }

  async function SaveOrUpdateFlexValue(data) {
    console.log(data);
    try {
      axios
        .post(
          "https://localhost:7229/api/Admin/SaveOrUpdateFlexValue",
          data,
          headers
        )
        .then(function (response) {
          console.log(response.data)
          setFlexValueListResponse(response.data);
          const foundErrorItem = response.data.errorMsg > 0;
          // console.log(foundErrorItem)
          if(!foundErrorItem){
            toast.success("Flex Value info save", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
          else{
            toast.error(foundErrorItem.errorMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                })
          }
        });
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
        console.log(err.response.status);
        console.log(err.response.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  }

  //Flex Set Value Save
  const handleFlexSetsave= async ()=>{
    console.log("ami handle clicked")
    let isFormvalid = false 
    const validationResults = [];
    validationResults.push(validationComp(flexshortnamemod3,setlabelflexshortnamemod3,setborderflexshortnamemod3,"Flex Short Name Required"))    
    validationResults.push(validationComp(flexsetnamemod3,setlabelflexsetnamemod3,setborderflexsetnamemod3,"Flex Set Name Required"))


    if (validationResults.every(result => result === true)) {
      isFormvalid = true; // Set isFormvalid to true if all results are true
    }
    if(isFormvalid){
      const mod3FinalArr = 
        {
          "fleX_VALUE_SET_NAME":flexsetnamemod3,
          "fleX_VALUE_SHORT_NAME":flexshortnamemod3
        }
        await SaveFlexSetValue(mod3FinalArr)
        setShow4(false)
        setflexsetnamemod3("");
        setflexshortnamemod3("");
    }
  }

  async function SaveFlexSetValue(addObj) {
    try {
      axios.post('https://localhost:7229/api/Admin/SaveFlexValueSet',addObj, headers)
      .then(function (response) {
        if (response.status == 200){
          setFlexSetResponse(response.data)
          toast.success("Flex Set Value save Successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }
      });
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
        console.log(err.response.status);
        console.log(err.response.header);
        
      } else {
        console.error(`Error: ${err.message}`);
      }
     
    }
}
  



  const [show,setShow] = useState("")

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)

  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4,setShow4] = useState(false);

  const handleClose = () => setShow2(false);
  const handleShow = () => {
    setShow2(true)
    if(flexvaluesetdrp){
      setlabelflexvaluesetMod1("")
      setborderflexvaluesetMod1("")
    }
  }
// eikhane2
const [SelectedRowId, setSelectedRowId] = useState(0);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = (e,myitem) => {
    setSelectedRowId(myitem.flexValueId)
    setflexnameMod2(myitem.flexValue)
    setflexshortnameMod2(myitem.flexShortValue)
    
    console.log(flexnameMod2)
    setShow3(true);
  }
  
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const handleactivetoMod1 = (activetoval)=>{

    if(activetoval != null){

        var dtmnt = activetoval.$M + 1;
        var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
        setactivetoMod1(dtfinalc)
    }
    
    
}
const handleactivefromMod1 = (activefromval)=>{

  if(activefromval != null){

      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
      setactivefromMod1(dtfinalc)
  }
  
  
}
  const handleactivetoMod2 = (activetoval)=>{

    if(activetoval != null){

        var dtmnt = activetoval.$M + 1;
        var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
        setactivetoMod2(dtfinalc)
    }
    
    
}
const handleactivefromMod2 = (activefromval)=>{

  if(activefromval != null){

      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
      setactivefromMod2(dtfinalc)
  }
  
  
}

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(flexValueTable.data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(flexValueTable.data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % flexValueTable.data.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setpaginatenumselected(event.selected);
    setItemOffset(newOffset);
  };
  const optionsFlexValueSet = [
    {
      id:1,
      opt:"Religion"
    },
    {
      id:2,
      opt:"Gender"
    },
    {
      id:3,
      opt:"Leave Type"
    },
  ]
  const optionsShowt = [
    {
      id:1,
      opt:1
    },
    {
      id:2,
      opt:2
    },
    {
      id:3,
      opt:3
    },
  ]

  const drpfuncshow=(myshow)=>{
    setShow(myshow)
  }

  const drpfuncflexnameMod1=(myval,myid)=>{
    setflexnameMod1(myval)
  }

  const drpfuncflexvalueset= async (myflexval, myflexId)=>{
    setflexvaluesetdrp(myflexval)
    setflexvaluesetIDdrp(myflexId)
    await GetFlexValueListBySelectedSet(myflexId);
  }
  async function GetFlexValueListBySelectedSet(flexSetId){
    try {
        axios.get(`https://localhost:7229/api/Admin/GetFlexValueBySetFlexValue?FlexSetId=${flexSetId}`, headers)
        .then(function (response) {
          if (response.status == 200){
              setFlexValueListResponse(response.data.item2)
                setshortnameMain(response.data.item1)
          }
        });
      } catch (err) {
        if (err.response) {
          console.error(err.response.data);
          console.log(err.response.status);
          console.log(err.response.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
}
  const handleActiveFrom = (activefromval)=>{

    if(activefromval != null){

        var dtmnt = activefromval.$M + 1;
        var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
        setactivefrom(dtfinalc)
    }
    
    
}
  const handleActiveTo = (activetoval)=>{

    if(activetoval != null){

        var dtmnt = activetoval.$M + 1;
        var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
        setactiveTo(dtfinalc)
    }
    
    
}
//start
  return (
    <>
      <div className="d-flex flexvaluecomp">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Flex Value"/>
          <div className="contentofadmindash contentflexvalue">
              <Row>
                <Col>
                  <div className="basicinput">
                    <p></p>
                  <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus/> New Flex Value</button>
                  </div>
                </Col> 
                <Col >
                <div className="basicinput">
                <p>Flex Value Set</p>
                <div className="dropdownwrapper">
                  
                    <Dropdown2 func={drpfuncflexvalueset} myplaceholder={flexvaluesetdrp?flexvaluesetdrp:""} fontsize="16" fontfamily="'Poppins', sans-serif"  options={FlexSetResponse}/>
                </div>
                </div>
                </Col>
                <Col>
                <div className="basicinputfield h40p">
                      <p>Short Name</p>
                      <div className="inputgap h35">
                              <input style={bordershortnameMain ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={shortnameMain} onChange={(e) => setshortnameMain(e.target.value)} />
                              <label>{labelshortnameMain}</label>
                            </div>
                      </div>
                </Col>
                <Col >
                  <div className="basicinput">
                    <p>Active from</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrom}
                          onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col >
                  <div className="basicinput">
                    <p>Active To</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activeto}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                </Col>
              </Row>
              <Row style={{marginTop:"20px"}}>
                <Col className="m-auto" lg={6}>
                  <Row>
                    <Col lg={3}>
                    <div className="basicinput">
                      <p>Show</p>
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                      </div>
                      </div>
                    </Col>
                    <Col lg={7}>
                            <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" />
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                <Col lg={2}>
                  <Purplebutton btnname="Flex Set" w="100%" h="40px" mt="17px" clickfunc={()=>setShow4(true)} />
                </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col lg={10} className="m-auto">
                  <div className="flexvaluetable oriflexvaltable">
                    <table>
                      <thead>
                        <tr>
                            {
                              flexValueTable.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      <tbody>
                        {
                          // responseeikhane
                          FlexValueListResponse?

                          FlexValueListResponse.map((item,key)=>{
                            return(
                              <tr>
                                <td>{item.flexValueId}</td>
                                <td>{item.flexValue}</td>
                                <td>{item.flexShortValue}</td>
                                <td>{item.attribute1}</td>
                                <td>{item.attribute2}</td>
                                <td>{item.attribute3}</td>
                                <td>{item.attribute4}</td>
                                <td>{item.attribute5}</td>
                                <td>
                                  <div className="img text-center">
                                  <img onClick={(e)=> handleShow3(e,item)} src="./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png" alt="" />    
                                  </div>  
                                </td>
                              </tr>
                            )
                          })
                          :""
                        }
                      </tbody>
                         
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">

                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {flexValueTable.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                </Col>
               
              </Row>

              <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Flex Value</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                      <p>Flex Name</p>
                      <div className="inputgap h35">
                              <input style={borderflexnameMod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexnameMod1} onChange={(e) => setflexnameMod1(e.target.value)} />
                              <label>{labelflexnameMod1}</label>
                            </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                        {/* ekhaneasho */}
                        <div className="basicinputfield h40p">
                        <p>Flex Value Set</p>
                        <div className="inputgap h40 ">
                        <div className="dropdownwrapper">
                          
                          <Dropdown2 err={borderflexvaluesetMod1} func={drpfuncflexvalueset} myplaceholder={flexvaluesetdrp?flexvaluesetdrp:""} fontsize="16" fontfamily="'Poppins', sans-serif"  options={FlexSetResponse}/>
                      </div>
                          <label>{labelflexvaluesetMod1}</label>
                        </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                      <p>Flex Short Name</p>
                      <div className="inputgap h35">
                              <input style={borderflexshortnameMod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexshortnameMod1} onChange={(e) => setflexshortnameMod1(e.target.value)} />
                              <label>{labelflexshortnameMod1}</label>
                            </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 1</p>
                            <div className="inputgap h35">
                              <input style={borderattribute1Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute1Mod1} onChange={(e) => setattribute1Mod1(e.target.value)} />
                              <label>{labelattribute1Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 2</p>
                            <div className="inputgap h35">
                              <input style={borderattribute2Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute2Mod1} onChange={(e) => setattribute2Mod1(e.target.value)} />
                              <label>{labelattribute2Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 3</p>
                            <div className="inputgap h35">
                              <input style={borderattribute3Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute3Mod1} onChange={(e) => setattribute3Mod1(e.target.value)} />
                              <label>{labelattribute3Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 4</p>
                            <div className="inputgap h35">
                              <input style={borderattribute4Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute4Mod1} onChange={(e) => setattribute4Mod1(e.target.value)} />
                              <label>{labelattribute4Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 5</p>
                            <div className="inputgap h35">
                              <input style={borderattribute5Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute5Mod1} onChange={(e) => setattribute5Mod1(e.target.value)} />
                              <label>{labelattribute5Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefromMod1}
                              onChange={(newvaldob)=>handleactivefromMod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefromMod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefromMod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                <Col lg={6}>
                <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetoMod1}
                              onChange={(newvaldob)=>handleactivetoMod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetoMod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetoMod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handleSaveFlexValue}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
              {/* modal2ori */}
              <Modal dialogClassName="mymodal2" show={show3} onHide={handleClose3} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Flex Value</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                      <p>Flex Name</p>
                      <div className="inputgap h35">
                              <input style={borderflexnameMod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexnameMod2} onChange={(e) => setflexnameMod2(e.target.value)} />
                              <label>{labelflexnameMod2}</label>
                            </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                    
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Flex Short Name</p>
                            <div className="inputgap h35">
                              <input style={borderflexshortnameMod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexshortnameMod2} onChange={(e) => setflexshortnameMod2(e.target.value)} />
                              <label>{labelflexshortnameMod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 1</p>
                            <div className="inputgap h35">
                              <input style={borderattribute1Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute1Mod2} onChange={(e) => setattribute1Mod2(e.target.value)} />
                              <label>{labelattribute1Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 2</p>
                            <div className="inputgap h35">
                              <input style={borderattribute2Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute2Mod2} onChange={(e) => setattribute2Mod2(e.target.value)} />
                              <label>{labelattribute2Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 3</p>
                            <div className="inputgap h35">
                              <input style={borderattribute3Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute3Mod2} onChange={(e) => setattribute3Mod2(e.target.value)} />
                              <label>{labelattribute3Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 4</p>
                            <div className="inputgap h35">
                              <input style={borderattribute4Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute4Mod2} onChange={(e) => setattribute4Mod2(e.target.value)} />
                              <label>{labelattribute4Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                            <p>Attribute 5</p>
                            <div className="inputgap h35">
                              <input style={borderattribute5Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute5Mod2} onChange={(e) => setattribute5Mod2(e.target.value)} />
                              <label>{labelattribute5Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefromMod2}
                              onChange={(newvaldob)=>handleactivefromMod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefromMod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefromMod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                <Col lg={6}>
                <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetoMod2}
                              onChange={(newvaldob)=>handleactivetoMod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetoMod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetoMod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <div className="d-flex">

                    <button variant="secondary" onClick={handleClose3}>
                      Close
                    </button>
              
                 
                    <button variant="primary" onClick={handlesaveMod2}>
                      Update
                    </button>
                  </div>
                  
                 
                 
                </Modal.Footer>
              </Modal>
              {/* modal3ori */}
              <Modal dialogClassName="mymodal" show={show4} onHide={handleClose4} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Flex Set</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                          <Row>
                          <Col lg={6}>
                          <div className="basicinputfield h40p">
                                  <p>Flex Set Name</p>
                                  <div className="inputgap h35">
                                    <input style={borderflexsetnamemod3 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexsetnamemod3} onChange={(e) => setflexsetnamemod3(e.target.value)} />
                                    <label>{labelflexsetnamemod3}</label>
                                  </div>
                                </div>
                          </Col>
                        
                          <Col lg={6}>
                          <div className="basicinputfield h40p">
                                  <p>Short Name</p>
                                  <div className="inputgap h35">
                                    <input style={borderflexshortnamemod3 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexshortnamemod3} onChange={(e) => setflexshortnamemod3(e.target.value)} />
                                    <label>{labelflexshortnamemod3}</label>
                                  </div>
                                </div>
                          </Col>
                          </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <div className="d-flex">

                    <button variant="secondary" onClick={handleClose4}>
                      Close
                    </button>
              
                 
                    <button variant="primary" onClick={handleFlexSetsave}>
                      Save
                    </button>
                  </div>
                  
                 
                 
                </Modal.Footer>
              </Modal>
          </div>
          <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
       </div>
      </div>
    </>
  )
}

export default FlexValueComp